import React from 'react';
import './FooterInfo.css';
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import { useState } from 'react';
import PrivacyPolicyModal from '../PrivacyPolicy/PrivacyPolicyModal';

const FooterInfo = (props) => {
    const [showPrivacy, setShowPrivacy] = useState(false);
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };

    let fadeInScreenHandler = (screen) => {
        if (screen.fadeInScreen !== props.id) return;
    
        Animations.animations.fadeInScreen(props.id);
      };
    
      const fadeInSubscription =
        ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Magna d.o.o. Sva prava zadržana.</p>
        
        <div className="footer-links">
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            Facebook
          </a>
          <a href="https://www.instagram.com/magna.doo/" target="_blank" rel="noopener noreferrer">
            Instagram
          </a>
          <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
        </div>

        <p onClick={() => setShowPrivacy(true)} style={{ cursor: 'pointer', color: '#64A6DA' }}>
        Politika privatnosti
      </p>

      {showPrivacy && <PrivacyPolicyModal onClose={() => setShowPrivacy(false)} />}

        <div className="footer-contact">
          <p>Adresa: Karađorđeva 2, Banja Luka</p>
          <p>Telefon: +387 66 469 253</p>
          <p>Email: magnakonsalting@gmail.com</p>
        </div>
      </div>

       {/* Strelica za povratak na vrh */}
       <button className="back-to-top" onClick={scrollToTop}>
        &#9650; {/* HTML kod za strelicu ka gore */}
      </button>
    </footer>
  );
};

export default FooterInfo;
